import PropTypes from "prop-types";

import SecondaryActionButton from "@/view/SecondaryActionsToolbar/SecondaryActionButton/index.js";
import PresentMobileAction from "./PresentMobileAction/PresentMobileAction.js";
import PresentOptions from "./PresentOptions/PresentOptions.js";

const propTypes = {
  actionName: PropTypes.string,
  activeSubMenu: PropTypes.string,
  contentId: PropTypes.string,
  content: PropTypes.object,
  eventProperties: PropTypes.object,
  handleToggleBannerMode: PropTypes.func,
  hoverLabel: PropTypes.string,
  icon: PropTypes.node,
  isMobile: PropTypes.bool,
  setActiveSubMenu: PropTypes.func,
  disabled: PropTypes.bool,
};

const VideoPresentAction = ({
  actionName,
  activeSubMenu,
  contentId,
  content,
  eventProperties,
  handleToggleBannerMode,
  hoverLabel,
  icon,
  isMobile,
  setActiveSubMenu,
  disabled,
}) => {
  const qaSelector = actionName.toLowerCase();

  const popOutContents = (
    <PresentOptions
      contentId={contentId}
      content={content}
      handleToggleBannerMode={handleToggleBannerMode}
      isMobile={isMobile}
    />
  );

  if (isMobile) {
    return (
      <PresentMobileAction
        actionName={actionName}
        activeSubMenu={activeSubMenu}
        disabled={disabled}
        eventProperties={eventProperties}
        icon={icon}
        popOutContents={popOutContents}
        setActiveSubMenu={setActiveSubMenu}
      />
    );
  }

  return (
    <SecondaryActionButton
      dataProps={{ "data-qa-selector": qaSelector }}
      eventProperties={eventProperties}
      hoverLabel={hoverLabel}
      icon={icon}
      popOutContents={popOutContents}
      title={actionName}
      disabled={disabled}
    />
  );
};

VideoPresentAction.propTypes = propTypes;

export default VideoPresentAction;
